var ConfigURL = {
    //"SERVER_URL": "https://git.kpru.ac.th/",
    "SERVER_URL": "https://mua.kpru.ac.th/",
}
export default ConfigURL;